export const EVENT_PROGRESS_V2_POLL_INTERVAL_MS = 30_000;
